var $72a312d948f0214b$exports = {};
$72a312d948f0214b$exports = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};


export {$72a312d948f0214b$exports as default};
//# sourceMappingURL=el-GR.mjs.map
